import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "../common/FormDialog";
import FormItem from "../form-item/FormItem";
import UserInfo from "../common/UserInfo";
import { asyncRequest } from "src/services/network";
import MerchantPicker from "../common/MerchantPicker";
import UserPicker from "../common/UserPicker";
import Confirm from "../common/ConfirmDialog";
import { useEffect } from "react";
import TreeSelect from "../lib/tree-select/TreeSelect";
import MerchantInfo from "../common/MerchantInfo";

const MerchantActivityAddDialog = ({ action, row, open, onClose, onUpdate }) => {
  const [form, setForm] = useState({
    mid: "",
    total: "",
  });

  const [merchant, setMerchant] = useState({});

  useEffect(() => {
    if (action !== "edit") return;

    setForm({
      mid: row.mid,
      total: row.total || "",
    });
    setMerchant(row);
  }, [row]);

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (!merchant.mid) return alert("请选择商户");
    if (!form.total) return alert("请输入金额");

    const { msg } = await asyncRequest({
      path: "/merchant/activity/add",
      data: {
        ...form,
        mid: merchant.mid,
      },
    });

    alert(msg, "success");
    onUpdate();
  }

  function handleSelectUser() {
    MerchantPicker({
      onSelect(val) {
        console.log(val);
        setMerchant(val);
      },
    });
  }

  return (
    <FormDialog title="添加商户" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="商户" required>
        <Stack onClick={handleSelectUser}>
          <MerchantInfo {...merchant} />
        </Stack>
      </FormItem>

      <FormItem title="活动金额" required>
        <TextField fullWidth type="number" placeholder="活动金额" autoComplete="off" id="total" value={form.total} size="small" onChange={(e) => handleIptChange("total", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default MerchantActivityAddDialog;
